module.exports = __webpack_public_path__ + "static/media/icon_jichengbushu.d2d32adb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/icon_jichengbushu.svg
// module id = 553
// module chunks = 0